import React from "react";
import { useTranslation } from "react-i18next";
import { Drawer } from "vaul";

interface MobileSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  children: React.ReactNode;
}

/**
 * Bottom sheet padrão do app mobile (arrastável para fechar), usado para
 * seleções e ações contextuais no lugar de dropdowns/menus de desktop.
 */
export const MobileSheet: React.FC<MobileSheetProps> = ({
  open,
  onOpenChange,
  title,
  children,
}) => {
  const { t } = useTranslation("common");

  return (
    <Drawer.Root open={open} onOpenChange={onOpenChange}>
      <Drawer.Portal>
        <Drawer.Overlay className="fixed inset-0 z-[60] bg-black/50" />
        <Drawer.Content className="fixed inset-x-0 bottom-0 z-[70] flex max-h-[85dvh] flex-col rounded-t-2xl border-t border-border bg-card outline-none">
          <div className="mx-auto mt-3 h-1.5 w-10 shrink-0 rounded-full bg-border" />
          {title ? (
            <Drawer.Title className="px-5 pb-1 pt-3 text-base font-semibold text-foreground">
              {title}
            </Drawer.Title>
          ) : (
            <Drawer.Title className="sr-only">{t("shared.menu")}</Drawer.Title>
          )}
          <div className="min-h-0 flex-1 overflow-y-auto px-4 pb-[max(env(safe-area-inset-bottom),16px)] pt-2">
            {children}
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
};
